<template>
  <div class="h100vh-116">
    <div class='h-ainfoBg'>
      <div class='h-ainfo'>
        <span class='icon hero-icon hero-icon-detailcode'></span>
        <span>{{$t('MCS.choosed')}} {{ chooseCount }} {{$t('MCS.num')}}</span>
      </div>
    </div>
    <div style="height: calc(100vh - 200px) !important;">
      <ejs-grid ref='grid' :dataSource="data" height="calc(100% - 0px)" :allowResizing='true' :rowDeselected='getChooseCount' :rowSelected='getChooseCount' :actionComplete='getChooseCount'>
        <e-columns>
          <e-column type='checkbox' headerText='groupid' width='30' textAlign='Center'></e-column>
          <e-column field='groupid' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.groupNum")' width='80' textAlign='Center'></e-column>
          <e-column field='grouptype' clipMode='EllipsisWithTooltip' :valueAccessor='grouptypeFormatter' :headerText='$t("MCS.groupType")' width='40' textAlign='Center'></e-column>
          <e-column field='groupalias' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.groupAlias")' width='180' textAlign='Center'></e-column>
          <e-column field='groupowner' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.groupOwner")' width='180' textAlign='Center'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref='pager' @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
    </div>
    <CustomDialog ref='addGroupPage' :element='dialog.element.eleAddGroup' :styles='dialog.styles'>
      <template v-slot:dialog-content>
        <AddGroupDialog ref='addGroup' opCode='0' :neid='neid'></AddGroupDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='modGroupPage' :element='dialog.element.eleModGroup' :styles='dialog.styles'>
      <template v-slot:dialog-content>
        <AddGroupDialog ref='modGroup' opCode='1' :neid='neid'></AddGroupDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='addGroupMemberPage' :element='dialog.element.eleAddGroupMember' :styles='dialog.styles'>
      <template v-slot:dialog-content>
        <AddGroupMemberDialog ref='addGroupMember' :neid='neid'></AddGroupMemberDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='qryGroupMemberPage' :element='dialog.element.eleModGroupMember' :styles='dialog.styles'>
      <template v-slot:dialog-content>
        <QryGroupMemberDialog ref='qryGroupMember' :neid='neid'></QryGroupMemberDialog>
      </template>
    </CustomDialog>
    <div v-if="gpsVif" class='h-pop-container'>
      <div class='h-pop-inside'>
        <div class='h-pop-top'>
          <div class='h-pop-title'>
            <div class='h-pop-height15d2'></div>
            <span style="font-size: 13px; font-weight: bold; color: #5a5a5a">{{$t('MCS.gpsGroupCallManage')}}</span>
          </div>
          <div class="h-pop-close">
            <div class='h-pop-height15d2'></div>
              <span class="e-btn-icon icon hero-icon hero-icon-remove-small h-pop-closeIcon" @click='closeGpsGroupCallPage'></span>
          </div>
        </div>
        <div class='h-pop-mid'>
          <GpsGroupCallDialog ref='gpsGroupCall'></GpsGroupCallDialog>
        </div>
        <div class='h-pop-bottom'>
          <div class="e-dialog">
            <div class="e-footer-content">
              <button type="button" class="e-control e-btn e-lib e-flat" data-ripple="true" @click='closeGpsGroupCallPage'>{{$t('MCS.cancle')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomDialog ref='superSearchPage' :element='dialog.element.eleSearch' :styles='dialog.stylesSearch'>
      <template v-slot:dialog-content>
        <SuperSearch ref='superSearch' :neid='neid' :userNumValue='userNumSearch' :reFreshGrid='reFreshGrid'></SuperSearch>
      </template>
    </CustomDialog>
    <CustomDialog ref='dialogPage' :element='dialogTip' :styles='styles'>
      <template v-slot:dialog-content>
        <DialogList ref='dialog' ></DialogList>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import { Edit, Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
import CustomDialog from '../../../common/CustomDialog';
import AddGroupDialog from './dialog/AddGroupDialog';
import AddGroupMemberDialog from './dialog/AddGroupMemberDialog';
import QryGroupMemberDialog from './dialog/QryGroupMemberDialog';
import GpsGroupCallDialog from './dialog/GpsGroupCallDialog';
import SuperSearch from './dialog/SearchDialog';
import DialogList from '../../util/tipDialog/DialogList';
import commonJS from '../common';

export default {
  name: 'GroupTable',
  components: {
    CustomDialog,
    AddGroupDialog,
    AddGroupMemberDialog,
    QryGroupMemberDialog,
    GpsGroupCallDialog,
    SuperSearch,
    DialogList
  },
  mixins: [commonJS],
  data() {
    return {
      data: {},
      gpsVif: false,
      groupId: '',
      userNumSearch: '',
      page: {
        pageNo: '1',
        pageSize: '100',
        totalCount: '0',
        pageCount: '0',
      },
      neid: '',
      equipmentIPId: '',
      vo: {
        flag: '',
        participantType: ''
      },
      chooseCount: 0,
      dialog: {
        styles: {
          width: '810px',
          height: '760px',
          model: true,
          visible: false
        },
        stylesGroupList: {
          width: '30%',
          height: '80%',
          visible: false,
          model: true
        },
        stylesSearch: {
          width: '400px',
          height: '270px',
          visible: false,
          model: true
        },
        element: {
          eleAddGroup: {
            target: this.$refs.userstable,
            refName: 'eleAddGroup',
            buttonGroup: [
              { click: this.closeAddGroupPage, buttonModel: { content: this.$t('MCS.cancle') } },
              { click: this.saveAddGroup, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.addGroup'),
            isClose: true
          },
          eleModGroup: {
            target: this.$refs.userstable,
            refName: 'eleModGroup',
            buttonGroup: [
              { click: this.closeModGroupPage, buttonModel: { content: this.$t('MCS.cancle') } },
              { click: this.saveModGroup, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.modGroup'),
            isClose: true
          },
          eleAddGroupMember: {
            target: this.$refs.userstable,
            refName: 'eleAddGroupMember',
            buttonGroup: [
              { click: this.closeAddGroupMemberPage, buttonModel: { content: this.$t('MCS.cancle') } }
            ],
            title: this.$t('MCS.addGroupMember'),
            isClose: true
          },
          eleModGroupMember: {
            target: this.$refs.userstable,
            refName: 'eleModGroupMember',
            buttonGroup: [
              { click: this.closeQryGroupMemberPage, buttonModel: { content: this.$t('MCS.cancle') } }
            ],
            title: this.$t('MCS.groupMemberManage'),
            isClose: true
          },
          eleSearch: {
            target: this.$refs.userstable,
            refName: 'eleSearch',
            buttonGroup: [
              { click: this.closenSuperSearchPage, buttonModel: { content: this.$t('MCS.cancle') } },
              { click: this.saveSuperSearch, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.superSearch'),
            isClose: true
          },
        },
      },
      dialogTip: {
        target: this.$refs.grouptable,
        refName: 'dialogList',
        buttonGroup: [
          { click: this.closeDialogListTipPage, buttonModel: { content: this.$t('MCS.cancle') } }
        ],
        title: this.$t('MCS.messageInfo'),
        isClose: true,
      },
    };
  },
  methods: {
    getGridData(ne = null) {
      const $this = this;
      let vo;
      if (ne !== null) {
        $this.neid = ne.data.id;
        $this.equipmentIPId = ne.data.equipmentIPId;
        vo = {
          flag: 0
        };
        this.clearCondition();
      } else {
        vo = {
          flag: 2,
          groupid: this.userNumSearch,
        };
      }
      const params = {
        info: this.setInfo(this.msg.qryGroups),
        vo: vo,
        page: {
          pageNo: $this.$refs.pager.ej2Instances.currentPage,
          pageSize: this.page.pageSize
        }
      };
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        if (response.data.errorCode === this.errorCode.breakLine) {
          $this.neid = '';
          $this.data = [];
          $this.$toast('warning', this.$t('Common.tips.noSelect'))
          return;
        }
        const res = response.data.resultVal;
        $this.data = res.result;
        $this.page.totalCount = res.countrsp;
      });
    },

    isChooseNe() {
      if (this.neid === '') {
        this.$toast('warning', this.$t('MCS.chooseNe'));
        return false;
      }
      return true;
    },

    getCheckedData(selectOnly) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        this.$toast('warning', this.$t('Common.tips.noSelect'));
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        this.$toast('warning', this.$t('MCS.onlyData'))
        return false;
      }
      return selectedRecords;
    },

    getCheckedVals(selectOnly = false) {
      const groupid = [];
      if (this.isChooseNe() !== false) {
        // x-> false: 不支持多选   true: 支持多选
        const checkedData = this.getCheckedData(selectOnly);
        for (let i = 0; i < checkedData.length; i++) {
          groupid.push(checkedData[i].groupid);
        }
      }
      return groupid;
    },

    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },

    /**
     * 打开/关闭/保存  添加群组页面
     */
    openAddGroupPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.addGroup.mainHandler();
      this.$refs.addGroupPage.show();
    },
    closeAddGroupPage() {
      this.$refs.addGroupPage.clear();
      this.$refs.addGroupPage.close();
    },
    saveAddGroup() {
      const $this = this;
      const datas = this.$refs.addGroup.getDatas();
      if (datas === false)  return;
      const params = {
        vo: datas,
        info: this.setInfo(this.msg.addGroup),
        log: {
          module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_group',
          execFunName: 'subscriber.addGroup',
          exectype: 1,
          execData: [datas.groupid]
        }
      };
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        try {
          if ($this.splitResult(response.data.resultVal[0].code) === '0') {
            $this.$toast('success');
          } else {
            $this.$toast('failure', response.data.resultVal[0].display);
          }
        } catch (e) {
          ;
        }
        this.getGridData();
      });
      this.$refs.addGroupPage.clear();
      this.$refs.addGroupPage.close();
    },

    /**
     * 打开/关闭/保存  修改群组页面
     */
    openModGroupPage() {
      const groupid = this.getCheckedVals();
      if (groupid.length !== 0) {
        const vo = {
          groupid: groupid[0],
          flag: 1
        };
        const page = {
          pageNo: 1,
          pageSize: 15
        };
        const params = {
          info: this.setInfo(this.msg.qryModGroup),
          vo: vo,
          page: page
        };
        this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
          const data = response.data.resultVal.result[0];
          this.$refs.modGroup.mainHandler(data);
          this.$refs.modGroupPage.show();
        });
      }
    },
    closeModGroupPage() {
      this.$refs.modGroupPage.clear();
      this.$refs.modGroupPage.close();
    },
    saveModGroup() {
      const $this = this;
      const datas = $this.$refs.modGroup.getDatas();
      if (datas === false)  return;
      const params = {
        vo: datas,
        info: $this.setInfo($this.msg.modGroup),
        log: {
          module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_group',
          execFunName: 'subscriber.modGroup',
          exectype: 1,
          execData: [datas.groupid]
        }
      };
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        try {
          if ($this.splitResult(response.data.resultVal[0].code) === '0') {
            $this.$toast('success');
          } else {
            $this.$toast('failure', response.data.resultVal[0].display);
          }
        } catch (e) {
          ;
        }
        this.getGridData();
      });
      this.$refs.modGroupPage.clear();
      this.$refs.modGroupPage.close();
    },

    /**
     * 删除群组
     */
    delGroups() {
      const $this = this;
      const groupid = this.getCheckedVals(true);
      if (groupid.length === 0) {
        return;
      };
      const _vo = this.voCycleSpell(new Map(), new Map().set('groupid', groupid), groupid.length);
      this.$layer.confirm({
        msg: this.$t('MCS.deleteConfirm'),
        btn1: {
          msg: this.$t('MCS.confirm'),
          func: () => {
            const params = {
              info: {
                neid: this.neid,
                msgid: this.msg.delGroup,
                operation: 'bacthOperate'
              },
              vo: {
                0: {
                  vo: _vo,
                  info: {
                    neid: this.neid,
                    msgid: this.msg.delGroup,
                    operation: 'bacthOperate',
                    mcsFlag: true
                  },
                }
              },
              log: {
                module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_group',
                execFunName: 'subscriber.delGroup',
                exectype: 1,
                execData: groupid
              }
            };
            const resObj = [];
            for (let i = 0; i < groupid.length; i++) {
              const resData = {};
              resData.operObj = groupid[i];
              resObj.push(resData);
            }
            this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
              resObj.forEach((item, index) => {
                item.operResult = response.data.resultVal[index].display;
                item.operCode = response.data.resultVal[index].code;
              });
              this.$refs.dialog.addOperetionResultList(resObj);
              $this.$refs.dialog.setTotalCount(groupid.length);
              $this.$refs.dialogPage.show();
              $this.getGridData();
            });
          }
        },
        btn2: {
          msg: this.$t('MCS.cancle')
        }
      });
    },

    /**
     * 打开/关闭/保存  添加组成员页面
     */
    openAddGroupMemberPage() {
      const groupid = this.getCheckedVals();
      if (groupid.length === 0) {
        return;
      }
      if (groupid.length !== 0) {
        this.$axios.post('/lte/ems/auth/findElementListByAuth', [12]).then((response) => {
          response.data.forEach((item) => {
            if (item.equipmentIPId === this.equipmentIPId) {
              this.$refs.addGroupMember.getGridData(groupid[0], item.id);
              this.$refs.addGroupMemberPage.show();
              return false;
            }
            return true;
          });
        });
      }
      this.$refs.addGroupMemberPage.show();
    },
    closeAddGroupMemberPage() {
      this.$refs.addGroupMemberPage.clear();
      this.$refs.addGroupMemberPage.close();
    },
    saveAddGroupMember() {
    },

    /**
     * 打开/关闭/保存  组成员管理页面
     */
    openQryGroupMemberPage() {
      const groupid = this.getCheckedVals();
      if (groupid.length !== 0) {
        this.$refs.qryGroupMember.getGridData(groupid[0]);
        this.$refs.qryGroupMemberPage.show();
      }
    },
    closeQryGroupMemberPage() {
      this.$refs.qryGroupMemberPage.clear();
      this.$refs.qryGroupMemberPage.close();
    },
    saveQryGroupMember() {
    },

    /**
     * 打开/关闭/保存  呼叫区域管理
     */
    openGpsGroupCallPage() {
      const groupid = this.getCheckedVals();
      const grouptype = this.$refs.grid.getSelectedRecords()[0].grouptype;
      if (grouptype !== 2) {
        this.$toast('warning', this.$t('MCS.chooseAreaGroup'));
        return ;
      };
      if (groupid.length !== 0) {
        this.groupId = groupid[0];
        this.gpsVif = true;
        this.$forceUpdate();
      };
    },
    closeGpsGroupCallPage() {
      this.gpsVif = false;
    },

    /**
     * 打开/关闭/保存  高级搜索页面
     */
    openSuperSearchPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.superSearchPage.show();
      this.$refs.superSearch.bindValidate();
    },
    closenSuperSearchPage() {
      this.$refs.superSearchPage.clear();
      this.$refs.superSearchPage.close();
    },
    saveSuperSearch() {
      if (!this.$refs.superSearch.checkValid()) {
        return;
      }
      this.$refs.superSearch.search();
      this.$refs.superSearchPage.clear();
      this.$refs.superSearchPage.close();
    },

    setInfo(msgid) {
      return {
        msgid: msgid,
        neid: this.neid,
      };
    },

    clearCondition() {
      this.userNumSearch = '';
      this.$refs.superSearch.setData('');
    },

    reFreshByNoCondition() {
      this.clearCondition();
      this.getGridData();
    },

    reFreshGrid(userNum) {
      this.userNumSearch = userNum;
      this.getGridData();
    },

    closeDialogListTipPage() {
      this.$refs.dialogPage.clear();
      this.$refs.dialogPage.close();
    },

  },
  provide: {
    grid: [Edit, Reorder, Resize, ExcelExport, ContextMenu]
  },
};
</script>

<style scoped>

</style>
